const namespace = 'bravissimo/editorial';

export const EDITORIAL_CONTENT_SUCCESS = `${namespace}/EDITORIAL_CONTENT_SUCCESS`;
export const RECEIVE_PAGE_CONTAINERS = `${namespace}/RECEIVE_PAGE_CONTAINERS`;
export const EDITORIAL_CONTENT_FAILURE = `${namespace}/EDITORIAL_CONTENT_FAILURE`;
export const EDITORIAL_CONTENT_REQUEST = `${namespace}/EDITORIAL_CONTENT_REQUEST`;
